export default {
  sm: `
  Management tools intuitively designed for 
  easy use and management are provided
  online. It is easy to build a cloud 
  environment with detailed manuals.    
  `,
  md: `
  Management tools intuitively designed for 
  easy use and management are provided
  online. It is easy to build a cloud 
  environment with detailed manuals.    
  `,
  lg: `
  Management tools intuitively designed for easy use and 
  management are provided online. It is easy to build a cloud 
  environment with detailed manuals.    
  `,
  xxl: `
  Management tools intuitively designed
  for easy use and management are provided
  online. It is easy to build a cloud 
  environment with detailed manuals.    
  `,
};
